import { CopyToClipboard } from "react-copy-to-clipboard";

import QRCodeCard from "../../../utils/QrCodeCard";
import numberWithCommas from "../../../utils/numbersWithComma";
import React from "react";
import { Toaster } from "../../../utils/toaster";
import { APP_CONST, SHOW_COPY_BUTTON } from "../../../config/const";
import { AiFillCopy } from "react-icons/ai";

const FORMAT_TYPES = {
  text: "string",
  number: "number",
  qrCodeValue: "qrcode",
  image: "image",
};

const RenderValue = ({ item }) => {
  switch (item?.format) {
    case FORMAT_TYPES.text:
      return (
        <div className="displaying-text-number">
          <div className="displaying-label">{`${item?.label}${
            item?.value && ":"
          }`}</div>
          <div className="displayng-text">{item?.value}</div>
        </div>
      );
    case FORMAT_TYPES.number:
      return (
        <div className="displaying-text-number">
          {" "}
          <div className="displaying-label">{`${item?.label} ${
            item?.value && ":"
          }`}</div>
          {item?.value && (
            <div className="displayng-text">
              {numberWithCommas(item?.value)}{" "}
            </div>
          )}
        </div>
      );
    case FORMAT_TYPES.qrCodeValue:
      return (
        <div>
          <div className="label">{`${item?.label}`}</div>
          <div className="displaying-qrcode">
            <QRCodeCard text={item?.value} />
          </div>
        </div>
      );
    case FORMAT_TYPES.image:
      return (
        <>
          <div className="QRSizeSection">
            <div className="label d-flex justify-content-between">
              <p>{`${item?.label}`} </p>
              {SHOW_COPY_BUTTON && (
                <CopyToClipboard
                  text={item?.label}
                  onCopy={() => {
                    Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                  }}
                >
                  <div
                    className="copyValueContent d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <AiFillCopy />
                    <div>Click to copy code</div>
                  </div>
                </CopyToClipboard>
              )}
            </div>

            <div className="image-container qrSize">
              <img className="displayng-img" src={item?.value} />
            </div>
          </div>
        </>
      );
    default:
      return (
        <div className="">
          {" "}
          {/* <div className="displaying-label">{`${item?.label}:`}</div> */}
          <div className="displayng-text">{item?.value}</div>
        </div>
      );
  }
};

const DisplayValues = ({ displayItems = [] }) => {
  return (
    <>
      {displayItems.length > 0 && (
        <>
          <div className={`display-values-section`}>
            {displayItems?.map((item, idx) => (
              <div key={idx} className="item">
                {/* <div className="displaying-label">{`${item?.label}:`}</div> */}
                <RenderValue item={item} />
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default DisplayValues;
